import {SListTabs} from "shj-components";
import ChannelCallBack from "@/pages/callConfig/channelCallBack";
import Seating from "@/pages/callConfig/seating";
import {getAuth} from "@/utils/auth.ts";

const CallConfiguration = () => {

  const items = [
    {
      key: 'channelCallBack',
      label: '通道回调配置',
      children: <ChannelCallBack/>,
      auth: 'channelCallBackTab',
    },
    {
      key: 'seating',
      label: '坐席配置',
      children: <Seating/>,
      auth: 'seatingTab',
    },
  ]

  return <SListTabs auth={getAuth()}
                    hideExtra={true}
                    items={items}
  />
}

export default CallConfiguration